module.exports = __webpack_public_path__ + "static/img/iphone-左5.c8e5fb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/index/dss/iphone-左5.png
// module id = rXR1
// module chunks = 0 2